document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-kv31-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-kv31-main-image]');
    const thumbs = [...gallery.querySelectorAll('[data-kv31-thumb]')];
    const counter = gallery.querySelector('[data-kv31-counter]');
    const total = gallery.querySelector('[data-kv31-total]');
    const openButton = gallery.querySelector('[data-kv31-open]');
    const lightbox = document.querySelector('[data-kv31-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-kv31-lightbox-image]');
    let currentIndex = 0;
    let touchStartX = 0;
    let swapTimer;

    if (!main || !thumbs.length) return;
    if (total) total.textContent = thumbs.length;
    gallery.classList.add('is-first-image');

    const updateOverlay = () => {
      gallery.classList.toggle('is-first-image', currentIndex === 0);
    };

    const commitImage = (thumb) => {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      const picture = main.closest('picture');
      picture?.querySelectorAll('source').forEach((source) => source.remove());
      main.src = thumb.dataset.full;
      main.alt = thumb.dataset.alt || '';
      main.onload = () => main.classList.remove('is-changing');
      if (main.complete) requestAnimationFrame(() => main.classList.remove('is-changing'));
    };

    const show = (nextIndex, focusThumb = false) => {
      currentIndex = (nextIndex + thumbs.length) % thumbs.length;
      const thumb = thumbs[currentIndex];

      clearTimeout(swapTimer);
      main.classList.add('is-changing');
      swapTimer = window.setTimeout(() => commitImage(thumb), 90);

      thumbs.forEach((button, index) => {
        const active = index === currentIndex;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });

      if (focusThumb) thumb.focus({ preventScroll: true });
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (counter) counter.textContent = currentIndex + 1;
      updateOverlay();

      if (lightboxImage && lightbox && !lightbox.hidden) {
        lightboxImage.src = thumb.dataset.full;
        lightboxImage.alt = thumb.dataset.alt || '';
      }
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => show(index));
      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
    });

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.classList.remove('kv31-lightbox-open');
      openButton?.focus();
    };

    openButton?.addEventListener('click', () => {
      if (!lightbox || !lightboxImage) return;
      const thumb = thumbs[currentIndex];
      lightbox.hidden = false;
      lightboxImage.src = thumb.dataset.full;
      lightboxImage.alt = thumb.dataset.alt || '';
      document.body.classList.add('kv31-lightbox-open');
      lightbox.querySelector('[data-kv31-close]')?.focus();
    });

    lightbox?.querySelector('[data-kv31-close]')?.addEventListener('click', closeLightbox);
    lightbox?.querySelector('[data-kv31-prev]')?.addEventListener('click', () => show(currentIndex - 1));
    lightbox?.querySelector('[data-kv31-next]')?.addEventListener('click', () => show(currentIndex + 1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') show(currentIndex - 1);
      if (event.key === 'ArrowRight') show(currentIndex + 1);
    });

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 45) show(currentIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
  });

  document.querySelectorAll('[data-kv31-youtube]').forEach((frame) => {
    const button = frame.querySelector('.kv31-video-facade');
    if (!button) return;

    button.addEventListener('click', () => {
      if (frame.classList.contains('is-loaded')) return;
      const videoId = frame.dataset.videoId;
      if (!videoId) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
      iframe.title = button.getAttribute('aria-label') || 'Product video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.classList.add('is-loaded');
      button.replaceWith(iframe);
    }, { once: true });
  });

});
